module.exports = __webpack_public_path__ + "static/media/pulsechain-card.ead95153.png";